import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'
import {getOpenTaskId, isLoading, isNeedToLoadData, isPanelOpened} from '../../panels/task/editPanel/selectors'
import {closeEditTaskPanel, copyLinkTo, openEditTaskPanel} from '../../panels/task/editPanel/actions'
import {loadEditTaskPanelData} from '../actions'
import EditTaskPanelContainer from '../../panels/task/editPanel/EditTaskPanelContainer'

export default connect(
    state => ({
        isShown: isPanelOpened(state),
        needToLoadData: isNeedToLoadData(state),
        loading: isLoading(state),
        openTaskId: getOpenTaskId(state),
    }),
    dispatch => ({
        openPanel: bindActionCreators(openEditTaskPanel, dispatch),
        onPanelHide: bindActionCreators(closeEditTaskPanel, dispatch),
        loadPanelData: bindActionCreators(loadEditTaskPanelData, dispatch),
        copyLink: bindActionCreators(copyLinkTo, dispatch),
    })
)(EditTaskPanelContainer)


// WEBPACK FOOTER //
// ./web/js/user/components/EditTaskPanelContainer.js